// import systemDataStatistics from "@/pages/dataStatistics/hpicSystemStatistics/hpicSystemStatistics"; //高压电离室数据分析
import systemData from "@/pages/dataStatistics/systemData"; //数据统计
import dataAcquisition from "@/pages/dataStatistics/dataAcquisition"; //数据获取率
import nuclideIdentification from "@/pages/dataStatistics/nuclideIdentification"; //能谱文件及核素识别
import comprehensive from "@/pages/dataStatistics/comprehensive"; //综合统计
export default [{
    path: "systemData/:type/:id/:deviceType/:name",
    name: "systemData",
    meta: {
      title: "数据统计",
      requireAuth: true
    },
    component: systemData,
  },
  {
    path: "dataAcquisition/:type/:id",
    name: "dataAcquisition",
    meta: {
      title: "数据获取率",
      requireAuth: true
    },
    component: dataAcquisition
  },
  {
    path: "nuclideIdentification/:type/:id",
    name: "nuclideIdentification",
    meta: {
      title: "能谱文件及核素识别",
      requireAuth: true
    },
    component: nuclideIdentification
  },
  {
    path: "comprehensive/:doseRateId/:rainfallId/:doseRate/:rainfall",
    name: "comprehensive",
    meta: {
      title: "剂量率和雨量",
      requireAuth: true
    },
    component: comprehensive
  }
];



// WEBPACK FOOTER //
// ./src/router/dataStatistics.js